import { gql } from '@apollo/client';
import { JobType } from 'shared/common/job-constants';
import { InterviewKind } from 'shared/models/interview';
import { CandidateDisqualReason } from 'shared/models/job-stages';

import {
    PipelineCandidateKey,
    PipelineCount,
    PipelineWhere,
    RecruiterPipelineRow
} from '../../common/recruiter-pipeline';

export interface RecruiterPipelineData {
    recruiters: RecruiterPipelineRow[];
}

export interface RecruiterPipelineVariables {
    args: {
        isDisqualified: boolean;
        jobTypes: JobType[];
        excludeClientIds: string[];
        startTime: number;
        endTime: number;
    };
}

export interface PipelineCandidate extends PipelineCandidateKey {
    person: { name: string };
    recruiter: { name: string };
    job: { title: string; client: { name: string } };
    stage: string;
    lastStageChangedAt: number;
    disqualifiedAt: number;
    disqualReason: CandidateDisqualReason;
}

export interface PipelineInterview extends PipelineCandidateKey {
    kind: InterviewKind;
    startTime: number;
}

export interface PipelineCandidatesData {
    candidates: PipelineCandidate[];
    total: PipelineCount;
}

export interface PipelineCandidatesVariables {
    where: PipelineWhere;
    limit: number;
    offset: number;
    orderBy: Array<{ disqualifiedAt?: 'desc'; lastStageChangedAt?: 'desc'; personId?: 'asc'; jobId?: 'asc' }>;
}

export const RECRUITER_PIPELINE = gql`
    query RecruiterPipeline($args: recruiter_pipeline_counts_args!) {
        recruiters: recruiter_pipeline_counts(
            args: $args
            order_by: [{ name: asc }, { id: asc }]
            limit: null
            offset: 0
        ) {
            id
            name
            username
            asOf
            phoneCalls
            phoneScreensComplete
            awaitingFeedback
            firstRounds
            secondRounds
            finalRounds
            offers
        }
    }
`;

export const PIPELINE_CANDIDATES = gql`
    query PipelineCandidates(
        $where: candidates_bool_exp!
        $limit: Int!
        $offset: Int!
        $orderBy: [candidates_order_by!]!
    ) {
        candidates(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
            personId
            jobId
            person {
                name(path: "full")
            }
            recruiter {
                name(path: "full")
            }
            job {
                title
                client {
                    name
                }
            }
            stage
            lastStageChangedAt
            disqualifiedAt
            disqualReason
        }
        total: candidates_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
`;

export const PIPELINE_INTERVIEWS = gql`
    query PipelineInterviews($where: interviews_bool_exp!) {
        interviews(where: $where, order_by: [{ startTime: desc }, { id: asc }], limit: null, offset: 0) {
            personId
            jobId
            kind
            startTime
        }
    }
`;
